"use client";
import React, { useContext } from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import { NotificationItem } from "./NotificationItem";
import * as _utils from "./utils";
import _styles from "./Topnav.module.css";
import { UserContext } from "../contexts/UserContexts";

const _interactionsData = JSON.parse(
  '{"events":{"e-61":{"id":"e-61","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-22","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-62"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"cbd4d820-eb54-5630-d3a7-0eb2ea91bf6b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"cbd4d820-eb54-5630-d3a7-0eb2ea91bf6b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1701790427962},"e-62":{"id":"e-62","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-23","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-61"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"cbd4d820-eb54-5630-d3a7-0eb2ea91bf6b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"cbd4d820-eb54-5630-d3a7-0eb2ea91bf6b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1701790427963}},"actionLists":{"a-22":{"id":"a-22","title":"notif [show]","actionItemGroups":[{"actionItems":[{"id":"a-22-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".notification-popup","selectorGuids":["f65d8899-d993-d636-0978-87ee9679e1d9"]},"value":"flex"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1701790432225},"a-23":{"id":"a-23","title":"notif [hide]","actionItemGroups":[{"actionItems":[{"id":"a-23-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".notification-popup","selectorGuids":["f65d8899-d993-d636-0978-87ee9679e1d9"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1701790451350}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function Topnav({ as: _Component = _Builtin.Block, inputDevices = [], outputDevices = [], onDeviceSelect, agentStatus, onStatusChange }) {
  _interactions.useInteractions(_interactionsData, _styles);
  const { user } = useContext(UserContext);

  return (
    <_Component className={_utils.cx(_styles, "top_container")} tag="div">
      <_Builtin.Heading className={_utils.cx(_styles, "top_header")} tag="h3">
        {"Dashboard"}
      </_Builtin.Heading>
      <div style={{ position: "relative", marginRight: "auto", paddingLeft: 50 }}>
        <span >Status: </span>
        <select name="agentStatus" value={agentStatus} onChange={onStatusChange}>
          <option value="offline">OFFLINE</option>
          <option value="online">ONLINE</option>
          <option value="busy">BUSY</option>
        </select>
      </div>
      <div style={{ position: "relative", marginRight: "auto", display: "flex" }}>
        <div style={{ paddingLeft: 10 }} >
          <span>Input: </span>
          <select name="inputDevices" onChange={onDeviceSelect}>
            {inputDevices.map((device) => (
              <option key={device.deviceId} value={device.deviceId}>{device.label}</option>
            ))}
          </select>
        </div>
        <div style={{ paddingLeft: 10 }} >
          <span >Speaker: </span>
          <select name="outputDevices" onChange={onDeviceSelect}>
            {outputDevices.map((device) => (
              <option key={device.deviceId} value={device.deviceId}>{device.label}</option>
            ))}
          </select>
        </div>
        <div style={{ paddingLeft: 10 }} >
          <button >Refresh Devices</button>
        </div>
      </div>


      <_Builtin.Block
        className={_utils.cx(_styles, "top_container_right")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "topnav-search")}
          tag="div"
        >
          <_Builtin.SearchForm
            className={_utils.cx(_styles, "search")}
            action="/search"
          >
            <_Builtin.SearchInput
              className={_utils.cx(_styles, "search-input")}
              autoFocus={false}
              disabled={false}
              maxLength={256}
              name="query"
              placeholder="Search…"
              required={true}
              type="search"
              id="search"
            />
            <_Builtin.SearchButton
              className={_utils.cx(_styles, "search-button")}
              type="submit"
              value=""
            />
          </_Builtin.SearchForm>
        </_Builtin.Block>
        <_Builtin.Link
          className={_utils.cx(_styles, "topnav_icon")}
          data-w-id="cbd4d820-eb54-5630-d3a7-0eb2ea91bf6b"
          button={false}
          block="inline"
          options={{
            href: "#",
          }}
        >
          <_Builtin.Image
            className={_utils.cx(_styles, "image-100")}
            loading="lazy"
            width="auto"
            height="auto"
            alt=""
            src="images/66968aed4d08d3826c761f92_crm-top-02.svg"
          />
        </_Builtin.Link>
        <_Builtin.Block
          className={_utils.cx(_styles, "notification-popup")}
          tag="div"
        >
          <NotificationItem />
          <NotificationItem />
          <NotificationItem />
          <NotificationItem />
          <NotificationItem />
        </_Builtin.Block>
        <_Builtin.Block
          className={_utils.cx(_styles, "topnav_user-container")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "topnav_user")}
            tag="div"
          >
            <_Builtin.Image
              className={_utils.cx(_styles, "image-100")}
              loading="lazy"
              width="auto"
              height="auto"
              alt=""
              src="images/66968aed4109b87855bdd83e_crm-top-01.png"
            />
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "topnav_usercontent")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "username")}
              tag="div"
            >
              {user.profile ? user.profile.firstName : ""} {user.profile ? user.profile.firstName : ""}
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "previewtext")}
              tag="div"
            >
              {user.email}
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
